<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="3">
        <el-input v-model="params.device_code" prefix-icon="el-icon-search" placeholder="输入设备编号查询" clearable @change="onSearch()" />
      </el-col>
      <el-col :span="3">
        <el-input v-model="pageData.filter" prefix-icon="el-icon-search" placeholder="输入设备名称查询" clearable @change="onSearch()" />
      </el-col>

      <el-col :span="3">
        <el-select v-model="share.queryCondition_1" placeholder="请选择" @change="queryConditionChange_1">
          <el-option
            v-for="item in queryConditionList_1"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>

      <el-col v-for="it in queryConditionList_1" :span="3" :key="it.value" :style="{display: it.value === share.queryCondition_1 ? '' : 'none' }">
        <el-select v-if="it.value === 'device_type_id'" v-model="params[it.value]" placeholder="请选择" @change="onSearch" clearable style="width: 100%;">
          <el-option
            v-for="item in share.device_typeList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>

        <el-input
          v-else
          :placeholder="`输入${it.label}查询`"
          v-model="params[it.value]"
          prefix-icon="el-icon-search"
          clearable
          @change="onSearch"/>
      </el-col>

      <el-col :span="3">
        <el-select v-if="isSystemRole" v-model="params.is_virtual" placeholder="全部设备类别" clearable @change="onSearch()" >
          <el-option
            v-for="item in virtuals"
            :key="item.value"
            :label="item.name"
            :value="item.value" />
        </el-select>
      </el-col>

      <el-col :span="4">
        <el-select v-if="isSystemRole" filterable v-model="params.owner_org_id" placeholder="所属客户" clearable @change="onSearch()" >
          <el-option
            v-for="item in share.ownerOrgList"
            :key="item.value"
            :label="item.text"
            :value="item.value" />
        </el-select>
      </el-col>

      <el-col :span="5" class="col_pos_right" align="right">
        <el-button v-permission="'增加设备'" icon="el-icon-plus" @click="addEquip()">添加设备</el-button>
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed" :show-overflow-tooltip="it.overflow">
          <template slot-scope="scope">
            <span v-if="it.key === 'is_enable'">{{scope.row[it.key] ? '启用' : '禁用'}}</span>
            <span v-else>{{scope.row[it.key]}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" min-width="230" label="操作">
          <template slot-scope="scope">
            <el-link v-for="item in operationShow" :key="item.key" :type="item.type" :disabled="item.disabled && item.disabled(scope.row.device_type_id)" @click="handleClick(item.operation, scope.row)">{{item.title}}</el-link>

            <el-dropdown v-if="operationHide.length" trigger="click" @command="(command)=>handleClick(command, scope.row)">
              <span class="el-dropdown-link"><i class="el-icon-more"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in operationHide" :key="item.key" :command="item.operation" :disabled="item.disabled && item.disabled(scope.row.device_type_id)">{{ item.title }}</el-dropdown-item>
                <el-dropdown-item>
                  <el-tooltip v-permission="'查看故障处理人'" effect="light" :content="`故障处理人: ${scope.row.warning_user_name}`">
                    <el-link>查看故障处理人</el-link>
                    <!-- icon="iconfont icon_11 icon-yonghu" -->
                  </el-tooltip>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange">
    </el-pagination>

    <el-dialog :width="dialogWidth + 'px'" :title="title" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @closed="componet_select = ''">
      <component :is="componet_select" :rowData="rowData" :deviceId="selectDeviceId" :isControllable="isControllable" :ownerOrgList="share.ownerOrgList" :supplyOrgList="share.supplyOrgList" @tableCloseDialog="dialogVisible = false" />
    </el-dialog>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import equipAdd from './add'
import equipEdit from './edit'
import FHandler from './FHandler'
import TFEquip from './TFEquip'
import moreInfo from './moreInfo'
import UDEquip from './UDEquip'
import UDRecord from './UDRecord'
import ETRecord from './ETRecord'
import PCRecord from './PCRecord'
import DRDParams from './DRDParams/index'
import Util from '@/api/util'
import BasicDataHelper from '@/api/basic_data_helper'
import { Permiss, getLoginUserInfo } from '@/api/permission'

export default {
  data () {
    return Backend.initListPage(this, 'device', {
      route_name: '设备列表',
      id_name: 'device_id',
      isSystemRole: getLoginUserInfo().isSystemRole,
      tableColList: [
        {
          key: 'device_code',
          name: '设备编号',
          fixed: true,
          overflow: true
        },
        {
          key: 'device_name',
          name: '设备名称'
        },
        {
          key: 'device_type_name',
          name: '设备类型'
        },
        {
          key: 'device_model_name',
          name: '设备型号'
        },
        {
          key: 'internet_connection_status_desp',
          name: '联网状态'
        },
        {
          key: 'is_enable',
          name: '启用状态'
        },
        {
          key: 'owner_org_name',
          name: '所属客户'
        },
        {
          key: 'work_time',
          name: '运行时长 (h)'
        }
      ],
      operations: [
        {
          key: 'checkParams',
          title: '查看参数',
          icon: 'icon_3 icon-chakanshezhi',
          permiss: '查看参数',
          operation: 'checkParams',
          type: 'primary',
          disabled: (id) => { return id !== '2' }
        },
        {
          key: 'issuedParams',
          title: '下发参数',
          icon: 'icon_4 icon-xiafa',
          permiss: '下发参数',
          operation: 'issuedParams',
          type: 'danger',
          disabled: (id) => { return id !== '2' }
        },
        {
          key: 'transferEquip',
          title: '转移设备',
          icon: 'icon_5 icon-zhuanyi-02',
          permiss: '转移设备',
          operation: 'transferEquip'
        },
        {
          key: 'edit',
          title: '编辑',
          icon: 'icon_1 icon-bianji',
          permiss: '编辑设备',
          type: 'primary',
          operation: 'editRow'
        },
        {
          key: 'delete',
          title: '删除',
          icon: 'icon_6 icon-shanchu',
          permiss: '删除设备',
          type: 'danger',
          operation: 'deleteRow'
        },
        {
          key: 'upgradeSoftware',
          title: '升级',
          icon: 'icon_7 icon-ruanjianshengji',
          permiss: '升级设备子系统软件',
          operation: 'upgradeSoftware',
          disabled: (id) => { return id !== '3' }
        },
        {
          key: 'licenseDownload',
          title: '下载许可证',
          icon: 'icon_7 icon-xiazai',
          permiss: '下载许可证',
          operation: 'licenseDownload',
          disabled: (id) => { return id !== '3' }
        },
        {
          key: 'updateRecord',
          title: '升级记录',
          icon: 'icon_8 icon-shengjijilu',
          permiss: '查看升级记录',
          operation: 'updateRecord',
          disabled: (id) => { return id !== '3' }
        },
        {
          key: 'equipTransferRecord',
          title: '设备转移记录',
          icon: 'icon_8 icon-lishijilu_huaban',
          permiss: '查看设备转移记录',
          operation: 'equipTransferRecord'
        },
        {
          key: 'parameControlRecord',
          title: '参数控制记录',
          icon: 'icon_10 icon-lishijilu',
          permiss: '查看参数控制记录',
          operation: 'parameControlRecord',
          disabled: (id) => { return id !== '2' }
        },
        {
          key: 'faultHandler',
          title: '更改故障处理人',
          icon: 'icon_11 icon-yonghu',
          permiss: '更改故障处理人',
          operation: 'faultHandler'
        },
        {
          key: 'moreInfo',
          title: '设备信息',
          icon: 'icon_9 icon-shebeixinxi',
          permiss: '查看设备信息',
          operation: 'moreInfo'
        }
      ],
      operationData: [],
      sortOperationData: [],
      virtuals: BasicDataHelper.virtuals,
      params: {
        device_type_id: '',
        device_model_name: '',
        owner_org_name: '',
        is_virtual: null,
        owner_org_id:''
      },
      queryConditionList_1: [
        {
          label: '设备类型',
          value: 'device_type_id'
        },
        {
          label: '设备型号',
          value: 'device_model_name'
        },
        {
          label: '所属客户',
          value: 'owner_org_name'
        }
      ],
      share: {
        queryCondition_1: 'device_type_id',
        device_typeList: [],
        ownerOrgList: [],
        supplyOrgList: []
      },
      dialogWidth: 600,
      dialogVisible: false,
      title: '',
      componet_select: '',
      rowData: {},
      selectDeviceId: null,
      isControllable: false
    })
  },

  components: {
    'equip-add': equipAdd,
    'equip-edit': equipEdit,
    'f-handler': FHandler,
    'tf-equip': TFEquip,
    'more-info': moreInfo,
    'ud-equip': UDEquip,
    'ud-record': UDRecord,
    'et-record': ETRecord,
    'pc-record': PCRecord,
    'drd-params': DRDParams
  },

  created () {
    this.operationData = this.$operationsFilter(this.operations)
    this.getUserFuncCount(this.operationData.map(it => Permiss[it.permiss]))

    this.getDeviceTypeList()
    this.getOwnerOrgList('org_customer')
    this.getOwnerOrgList('org_provider')
  },

  computed: {
    operationShow () {
      return this.sortOperationData.slice(0, 2)
    },
    operationHide () {
      return this.sortOperationData.slice(2)
    }
  },

  methods: {
    getDeviceTypeList () {
      Backend.filterKeyValueList(this, 'device_type')
    },
    getOwnerOrgList (service) {
      const url = `/${service}/cmd/list/key_field/org_name/value_field/org_id/max_results/1000/text/`
      Backend.get(this, url, 30).then(data => {
        switch (service) {
          case 'org_customer':
            this.share.ownerOrgList = data.items
            break
          case 'org_provider':
            this.share.supplyOrgList = data.items
            break
        }
      })
    },
    getUserFuncCount (funcIds) {
      if (funcIds.length < 1) return
      const arr = []
      Backend.post(this, '/role/get_user_func_count', { func_ids: funcIds }).then((data) => {
        data.sorted.forEach(id => {
          arr.push(this.operationData.find(it => Number(Permiss[it.permiss]) === Number(id)))
        })
        this.sortOperationData = arr
      }).catch(() => {
        this.sortOperationData = this.operationData
      })
    },
    queryConditionChange_1 () {
      this.params.device_type_id = ''
      this.params.device_model_name = ''
      this.params.owner_org_name = ''
      this.onSearch()
    },
    addEquip () {
      this.dialogWidth = 600
      this.generalFunc('添加设备', 'equip-add', {})
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    },
    handleClick (operation, row) {
      if (operation) this[operation](row)
    },
    checkParams (row) {
      this.dialogWidth = 1000
      this.isControllable = false
      this.generalFunc('设备上报参数', 'drd-params', row)
    },
    issuedParams (row) {
      this.dialogWidth = 1000
      this.isControllable = true
      this.generalFunc('设备下发参数', 'drd-params', row)
    },
    transferEquip (row) {
      this.dialogWidth = 600
      this.generalFunc('转移设备', 'tf-equip', row)
    },
    editRow (row) {
      this.dialogWidth = 600
      this.generalFunc('编辑设备', 'equip-edit', row)
    },
    deleteRow (row) {
      Backend.deleteRow(this, row, '设备')
    },
    upgradeSoftware (row) {
      if (row.internet_connection_status === 1) {
        this.$message.warning('设备离线,无法升级!')
        return
      }
      this.dialogWidth = 600
      this.generalFunc('升级设备', 'ud-equip', row)
    },
    updateRecord (row) {
      this.dialogWidth = 1000
      this.generalFunc('升级记录', 'ud-record', row)
    },
    licenseDownload (row) {
      Backend.postFile(this, 'device/download_license', { device_id: row.device_id }).then((res) => {
        Util.downLoadBinary(res, 'license.txt')
      })
    },
    equipTransferRecord (row) {
      this.dialogWidth = 800
      this.generalFunc('设备转移记录', 'et-record', row)
    },
    moreInfo (row) {
      this.dialogWidth = 600
      this.updateUserFuncCount(Permiss['查看设备信息'])
      this.generalFunc('设备信息', 'more-info', row)
    },
    parameControlRecord (row) {
      this.dialogWidth = 800
      this.generalFunc('参数控制记录', 'pc-record', row)
    },
    faultHandler (row) {
      this.dialogWidth = 600
      this.generalFunc('更改故障处理人', 'f-handler', row)
    },
    generalFunc (title, componet, row) {
      this.title = title
      this.dialogVisible = true
      this.componet_select = componet
      this.selectDeviceId = row.device_id
      this.rowData = row
    },
    updateUserFuncCount (funcId) {
      Backend.post(this, '/role/update_user_func_count', { func_id: funcId })
    }
  }
}
</script>
